/**
 * One frame on the board: its rectangle and its title (written in place). What a GUI pack draws
 * on frames where it takes part comes with it (`packs.frameDecor()`: classes, words before and
 * after the title; UI/UX's: a component's ◇, the start flag, the device).
 */
import { For, type JSX } from "solid-js";
import { Dynamic } from "solid-js/web";
import { useApp } from "../../../app/context";
import type { BoardFrame } from "../../../state/board";
import { Editable } from "./Editable";
import { frameCss, placeCss } from "./look";

/** One frame (`titlePx`: the title's size in board units). */
export function Frame(props: { frame: BoardFrame; selected: boolean; titlePx: number; editing: boolean; done: () => void }): JSX.Element {
  const { board, packs } = useApp();
  const f = () => props.frame;
  const id = () => f().id;
  /** The classes the packs taking part give it. */
  const classes = () => Object.assign({}, ...packs.frameDecor().map((d) => d.classes?.(f()) ?? {})) as Record<string, boolean>;
  return (
    <div
      class="board-frame"
      classList={{ selected: props.selected, ...classes() }}
      data-frame={id()}
      data-device={f().group.style?.device}
      style={{ ...placeCss(f().place), ...frameCss(f().group.style ?? {}) }}
    >
      <div class="board-frame-title" data-frame-title={id()} style={{ "font-size": `${props.titlePx}px` }}>
        <For each={packs.frameDecor()}>{(d) => d.Before && <Dynamic component={d.Before} frame={f()} />}</For>
        <Editable text={f().group.name} editing={props.editing} done={props.done} write={(text) => void board.setText(id(), text)} />
        <For each={packs.frameDecor()}>{(d) => d.After && <Dynamic component={d.After} frame={f()} />}</For>
      </div>
    </div>
  );
}
